import UXSiblingSet from '@ux/sibling-set';
import '@ux/sibling-set/styles';
import { PropsWithChildren } from 'react';

export type Props = PropsWithChildren<{
  className?: string;
  divider?: boolean;
  gap?: 'sm' | 'md' | 'lg';
  id?: string;
  invalid?: boolean | 'grammar' | 'spelling';
  label?: string;
  helpMessage?: string;
  errorMessage?: string;
  orientation?: 'horizontal' | 'vertical';
  required?: boolean;
  stretch?: boolean;
  wrap?: boolean;
}>;

export default function SiblingSet(props: Props) {
  return <UXSiblingSet {...props} />;
}
